import type { SendLogOptions, SendEventOptions } from './types';

const GLOBAL_NAME = 'KSlardarWeb';

function getSlardarInstance():
  | ((method: string, ...args: unknown[]) => void)
  | null {
  try {
    if (typeof window === 'undefined') {
      return null;
    }
    const instance = window[GLOBAL_NAME];
    if (typeof instance === 'function') {
      return instance;
    }
    return null;
  } catch {
    return null;
  }
}

export const slardar = {
  sendLog(options: SendLogOptions): void {
    try {
      const instance = getSlardarInstance();
      if (!instance) return;
      instance('sendLog', {
        content: options.content,
        level: options.level ?? 'info',
        extra: { ...options.extra, team: 'miaoda-sdk' },
      });
    } catch {
      // slardar 调用失败不应影响业务
    }
  },

  sendEvent(options: SendEventOptions): void {
    try {
      const instance = getSlardarInstance();
      if (!instance) return;
      instance('sendEvent', {
        name: options.name,
        metrics: options.metrics,
        categories: { ...options.categories, team: 'miaoda-sdk' },
      });
    } catch {
      // slardar 调用失败不应影响业务
    }
  },

  captureException(error: unknown, extra?: Record<string, string>): void {
    try {
      const instance = getSlardarInstance();
      if (!instance) return;
      instance('captureException', error, { ...extra, team: 'miaoda-sdk' });
    } catch {
      // slardar 调用失败不应影响业务
    }
  },
};
